import React from 'react'
import styles from "./LLC.module.scss"
import { useNavigate } from 'react-router-dom'
import { useConfig } from './../../../app/configcontext';
import { useDispatch } from 'react-redux'
import { businessSlice } from "../../../features/business/businessSlice";
import { list_items } from '../../configration_data/configration';
import  llcbanner from "../../assets/llc_bnr.jpg"
import imgOne from "../../assets/LLC_img/keyhole.png";
import imgTwo from "../../assets/LLC_img/diagram.png";
import imgThree from "../../assets/LLC_img/mountains.png";
import ProtectedPaymentRoute from '../../auth/Auth';


export default function LLC() {
  ProtectedPaymentRoute()

  const actions = businessSlice.actions
  const dispatch = useDispatch()
  const config = useConfig();
  const packages = config.packages
  console.log("Packages: ", packages)
  const navigate = useNavigate()
  const handlePackageSelect = (selectedPackage) => {
    console.log("Selected package: ", selectedPackage.id)
    dispatch(actions.update_package_id(selectedPackage.id))
    navigate("/business_name")
  };
  return (
    <div>
      <section className={styles.llc_bnr}>
        <img src={llcbanner} alt='' />
      </section>
      <section className={styles.pkg}>
        <div className='container'>
          <div className={styles.heading}>
            <h2>Tailored Formation Packages for Your Business Success</h2>
            <p>Welcome to your business journey's starting point. Explore our special packages made just for you. They're more than just services
              —they're like roads made to match your special business plans.</p>
          </div>
          <div className={styles.pkg_wrp}>
            {packages && packages.map((ele) => {
              return (
                <>
                  <div className={styles.pkg_box} key={ele.id}>
                    <div className={styles.card_heading}>
                      <h3>{ele.name}</h3>
                      <div>
                        <h6>plus state filing fees</h6>
                        <h4>${ele.price}<span>/{ele.periodName}</span></h4>
                      </div>
                    </div>
                    <p>{ele.description}</p>
                    <div className={styles.card_ftr}>
                      <button onClick={() => handlePackageSelect(ele)} >Register LLC<i className="fa-solid fa-arrow-right"></i></button>
                      {ele.name === "StartRight" && (
                        <img src={imgOne} alt='' />
                      )} 

                      {ele.name === "BizBoost" && (
                        <img src={imgTwo} alt='' />
                      )}

                      {ele.name === "EntityElite" && (
                        <img src={imgThree} alt='' />
                      )} 
                    </div>
                  </div>
                </>
              )
            })}

          </div>
          <div className={styles.list_For_Start_Price}>
            <ul>
              {list_items.map(ele => <li><i className="fa-solid fa-angles-right"></i>{ele.name}</li>) }
            </ul>
          </div>
        </div>
      </section>
    </div>
  )
}
